import React, { useState, useEffect } from "react";
import { useParams, Link } from "react-router-dom";
import axios from "axios";
import {
  CContainer,
  CRow,
  CCol,
  CCard,
  CCardBody,
  CSpinner,
  CAlert,
} from "@coreui/react";
import i18n from "../../../i18n";

const EmailVerificationPage = () => {
  const { uid, token } = useParams();
  const [verificationStatus, setVerificationStatus] = useState("pending");
  const [message, setMessage] = useState("i18n.t('email_verification_page.checking_link', 'Проверяем вашу ссылку...')");

  useEffect(() => {
    if (uid && token) {
      const verifyEmail = async () => {
        try {
          const response = await axios.get(
            `/api/verify-email/${uid}/${token}/`,
          );
          setVerificationStatus("success");
          setMessage(response.data.message);
        } catch (error) {
          setVerificationStatus("error");
          setMessage(
            error.response?.data?.error || "i18n.t('email_verification_page.error_checking', 'Произошла ошибка при проверке.')",
          );
        }
      };
      verifyEmail();
    } else {
      setVerificationStatus("error");
      setMessage("i18n.t('email_verification_page.invalid_verification_link', 'Неверная ссылка для верификации.')");
    }
  }, [uid, token]);

  const renderContent = () => {
    switch (verificationStatus) {
      case "pending":
        return (
          <div className="text-center">
            <CSpinner color="primary" />
            <p className="mt-3">{message}</p>
          </div>
        );
      case "success":
        return (
          <CAlert color="success" className="text-center">
            <h4>{message}</h4>
            <p>
              Теперь вам нужно дождаться, пока администратор активирует вашу
              организацию.
            </p>
            <p>
              Напишите нашему менеджеру в Telegram{" "}
              <a
                href="https://t.me/neimarker"
                target="_blank"
                rel="noopener noreferrer"
              >
                @neimarker
              </a>{" "}
              для ускорения процесса.
            </p>
          </CAlert>
        );
      case "error":
        return (
          <CAlert color="danger" className="text-center">
            <h4>{message}</h4>
          </CAlert>
        );
      default:
        return null;
    }
  };

  return (
    <div className="bg-light min-vh-100 d-flex flex-row align-items-center">
      <CContainer>
        <CRow className="justify-content-center">
          <CCol md={6}>
            <CCard className="p-4">
              <CCardBody>
                {renderContent()}
                <div className="text-center mt-3">
                  <Link to="/login">i18n.t('email_verification_page.go_to_login', 'Перейти на страницу входа')</Link>
                </div>
              </CCardBody>
            </CCard>
          </CCol>
        </CRow>
      </CContainer>
    </div>
  );
};

export default EmailVerificationPage;